import React from 'react';
import { Menu, X } from 'lucide-react';

const Header = ({ 
  isSidebarOpen, 
  setIsSidebarOpen, 
  apiKey 
}) => {
  return (
    <div className="header">
      <div className="header-left">
        <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="menu-btn">
          {isSidebarOpen ? <X className="icon-small" /> : <Menu className="icon-small" />}
        </button>
        <h1>キャリア相談チャットボット</h1>
      </div>
      
      {apiKey && (
        <div className="api-status">
          <div className="status-indicator"></div>
          API接続済み
        </div>
      )}
    </div>
  );
};

export default Header;